module.exports = {"361030100":"盱江镇","361030101":"头陂镇","361030103":"赤水镇","361030104":"驿前镇","361030105":"甘竹镇","361030106":"塘坊镇","361030200":"千善乡","361030201":"水南圩乡","361030202":"长桥乡","361030203":"杨溪乡","361030204":"尖峰乡","361030400":"翠雷山垦殖场","361030500":"广昌县工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361030.json
// module id = 1237
// module chunks = 0